export const reactTemplate = (appImport: string) => [
  `import React from "react";`,
  `import ReactDOM from "react-dom";`,
  `window.dispatchEvent(new Event("rendering"));`,
  `import App from ".${appImport}";`,
  `ReactDOM.render(<App />, document.getElementById("sample-container"));`,
  `console.log("Sandbox Preview rendering");`
].join("\n");

export const reactLegacyTemplate = (appImport: string) => [
  `import React from "react";`,
  `import ReactDOM from "react-dom";`,
  `import { AuthorizationClient, ViewerContextProvider } from "@itwin/sandbox";`,
  `import App from ".${appImport}";`,
  `AuthorizationClient.initializeOidc()`,
  `  .then(() => {`,
  `    ReactDOM.render(<ViewerContextProvider authClient={AuthorizationClient.oidcClient}><App /></ViewerContextProvider>, document.getElementById("sample-container"));`,
  `    console.log("Sandbox Preview rendering");`,
  `  })`,
  `  .finally(() => window.dispatchEvent(new Event("rendering")));`
].join("\n");